import React, { useEffect, useState } from 'react';
import '../css/App.css';
import {
    BrowserRouter as Router,
    Switch,
    Route
} from "react-router-dom";

import Index from '../view/Index'
import Home from '../view/Home'
import Customer from '../view/Customer'
import ActivityResult from '../view/activity/result'
import Homeroom from '../view/Homeroom'
import Report from '../view/report/Report'
import ActivityLive from '../view/activity/Live'
import ActivitySummary from '../view/activity/ActivitySummary'
import Activity from '../view/activity/ChooseActivity'
import TopicPage from '../view/activity/TopicPage'
import ReportOverview from '../view/report/Overview'
import LoginPage from '../view/auth/CognitoLogin'
import PasswordCreated from '../view/auth/PasswordCreated'
import PdfFile from '../view/report/PdfFile'
import { Col } from 'react-bootstrap';
import AuthService from "../controllers/AuthService";
import { Redirect } from 'react-router-dom'
import UserService from "../controllers/UserService";
import SessionGuard from "../controllers/SessionGuard";
import IndexEvaluate from '../view/evaluate/IndexEvaluate';
import OverviewEvaluate from '../view/evaluate/OverviewEvaluate';
import PersonEvaluate from '../view/evaluate/PersonEvaluate';
import RoomOverviewEvaluate from '../view/evaluate/RoomOverviewEvaluate';
import ReportFriendship from '../view/report/Friendship';
import ReportFriendshipTarget from '../view/report/FriendshipTarget';
import ReportSelfDevelopment from '../components/ReportSelfDevelopment';
import ReportFriendshipOverview from '../view/report/ReportFriendshipOverview';
// import Graph from '../view/evaluate/Graph';
import GeneratePDF from '../view/pocketbook/GeneratePDF';
import PocketbookStudentList from '../view/pocketbook/PocketbookStudentList';
import PocketbookStudentDetail from '../view/pocketbook/PocketbookStudentDetail';
import ExportReportFriendshipTarget from '../components/ExportFriendshipTarget';
import PdfDevelopSelf from '../view/report/PdfDevelopSelf'
import RFResult from '../view/riasec-form/RFResult'
import RFStudentEvaluate from '../view/riasec-form/RFStudentEvaluate'
import RFStudentQRCode from '../view/riasec-form/RFStudentQRCode'
import RFReportStudentList from '../view/riasec-form/RFReportStudentList'
import RFStudentList from '../view/riasec-form/RFStudentList'
import ExportRFResult from '../view/riasec-form/ExportRFResult'
import RiasecMeaning from '../view/riasec-form/RiasecMeaning'
import StrengthDetails from '../view/strengths/StrengthDetails.js'
import ReportMainHeadmaster from '../view/report/ReportMainHeadmaster';
import PdfStudentEvaluateTeacherReport from '../view/report/PdfStudentEvaluateTeacherReport';

const WebRoute = props => {

    const pushValueToMain = (v) => {
        props.onChange(v)
    }
    const [hasOnlineActivity, setHasOnlineActivity] = useState(false);

    useEffect(() => {
        // ตัด session รายวัน: เช็คตอนเปิดหน้า และเช็คซ้ำทุกครั้งที่กลับมาที่แท็บ
        // (แท็บที่เปิดค้างข้ามคืนจะไม่มี mount ใหม่ให้ตรวจ)
        SessionGuard.enforceDailySession();
        const unwatchDailySession = SessionGuard.watchDailySession();

        if (AuthService.getCurrentUser() && AuthService.getUserRole() === 'teacher' && AuthService.getCurrentUser().domain && AuthService.getCurrentUser().domain.name) {
            UserService.getActivities({
                'status': 'RUNNING',
                'roomId': AuthService.getCurrentUser() && AuthService.getCurrentUser().room && AuthService.getCurrentUser().room.id ? AuthService.getCurrentUser().room.id : '1',
                'domain': AuthService.getCurrentUser() && AuthService.getCurrentUser().domain && AuthService.getCurrentUser().domain.name ? AuthService.getCurrentUser().domain.name : '2'
            }).then((res) => {
                if (res.data.data.length > 0) {
                    setHasOnlineActivity(true)
                }
            })
        }

        return unwatchDailySession;
    }, [])

    return (
        <Col>
            <Router>
                {(AuthService.getCurrentUser() && AuthService.getUserRole() === 'headmaster') ?
                    <Switch>
                        {/* <Route path="/customer">
                                <Customer onChange={value => pushValueToMain(value)} />
                            </Route> */}
                        {/* <Route path="/about">
                                <Customer onChange={value => pushValueToMain(value)} />
                            </Route> */}
                        {/* <Route path="/us">
                                <Customer onChange={value => pushValueToMain(value)} />
                            </Route> */}
                        {/* <Route path="/homeroom">
                                <Homeroom onChange={value => pushValueToMain(value)} />
                            </Route> */}

                        <Route path="/report/friendship/export/student-evaluate-teacher/:roomId/:teacherId">
                            <PdfStudentEvaluateTeacherReport onChange={value => pushValueToMain(value)} />
                        </Route>
                        <Route path="/report/friendship/export/:target/:roomId/:studentId">
                            <ExportReportFriendshipTarget onChange={value => pushValueToMain(value)} />
                        </Route>
                        <Route path="/report/riasec/export/:target/:roomId/:studentId">
                            <ExportRFResult onChange={value => pushValueToMain(value)} />
                        </Route>
                        <Route path="/report/friendship/:roomId">
                            <ReportFriendshipOverview onChange={value => pushValueToMain(value)} />
                        </Route>
                        <Route path="/report/pdffile/:keyType/:activityId/:code/:studentId?">
                            <PdfFile onChange={value => pushValueToMain(value)} />
                        </Route>
                        <Route path="/report/pdfdevelopself/:roomId/:code/:studentId">
                            <PdfDevelopSelf onChange={value => pushValueToMain(value)} />
                        </Route>
                        <Route path="/report/overview/:roomId">
                            <ReportOverview onChange={value => pushValueToMain(value)} />
                        </Route>
                        <Route path="/report/riasec/:roomId/:studentId">
                            <RFResult onChange={value => pushValueToMain(value)} />
                        </Route>
                        <Route path="/report/riasec/:roomId">
                            <RFReportStudentList onChange={value => pushValueToMain(value)} />
                        </Route>
                        <Route path="/report">
                            <ReportMainHeadmaster onChange={value => pushValueToMain(value)} />
                        </Route>
                        <Route path="/report-old">
                            <Report onChange={value => pushValueToMain(value)} />
                        </Route>
                        <Route path="/pocketbook/pdf/:roomIdParams/:stdId">
                            <GeneratePDF onChange={value => pushValueToMain(value)} />
                        </Route>
                        <Route path="/pocketbook/student/:roomId/:studentId">
                            <PocketbookStudentDetail onChange={value => pushValueToMain(value)} />
                        </Route>
                        <Route path="/pocketbook/:roomId">
                            <PocketbookStudentList onChange={value => pushValueToMain(value)} />
                        </Route>
                        <Route path="/riasec/meaning">
                            <RiasecMeaning onChange={value => pushValueToMain(value)} />
                        </Route>
                        <Route path="/strength/detail">
                            <StrengthDetails onChange={value => pushValueToMain(value)} />
                        </Route>
                        <Route path="/">
                            <Index onChange={value => pushValueToMain(value)} />
                        </Route>
                    </Switch>
                    : (AuthService.getCurrentUser() && AuthService.getUserRole() === 'teacher' && hasOnlineActivity === true) ?
                        <Switch>
                            <Route path="/activity/live/:activityId">
                                <ActivityLive onChange={value => pushValueToMain(value)} />
                            </Route>
                            <Route path="/">
                                <Index onChange={value => pushValueToMain(value)} />
                            </Route>
                        </Switch>
                        : (AuthService.getCurrentUser() && AuthService.getUserRole() === 'teacher') ?

                            <Switch>
                                {/* <Route path="/customer">
                                <Customer onChange={value => pushValueToMain(value)} />
                            </Route>
                            <Route path="/about">
                                <Customer onChange={value => pushValueToMain(value)} />
                            </Route>
                            <Route path="/us">
                                <Customer onChange={value => pushValueToMain(value)} />
                            </Route> */}

                                <Route path="/report/friendship/export/student-evaluate-teacher/:roomId/:teacherId">
                                    <PdfStudentEvaluateTeacherReport onChange={value => pushValueToMain(value)} />
                                </Route>
                                <Route path="/report/friendship/export/:target/:roomId/:studentId">
                                    <ExportReportFriendshipTarget onChange={value => pushValueToMain(value)} />
                                </Route>
                                <Route path="/report/riasec/export/:target/:roomId/:studentId">
                                    <ExportRFResult onChange={value => pushValueToMain(value)} />
                                </Route>
                                <Route path="/homeroom">
                                    <Homeroom onChange={value => pushValueToMain(value)} />
                                </Route>
                                <Route path="/report/pdffile/:keyType/:activityId/:code/:studentId?">
                                    <PdfFile onChange={value => pushValueToMain(value)} />
                                </Route>
                                <Route path="/report/pdfdevelopself/:roomId/:code/:studentId">
                                    <PdfDevelopSelf onChange={value => pushValueToMain(value)} />
                                </Route>
                                <Route path="/report/overview/:roomId">
                                    <ReportOverview onChange={value => pushValueToMain(value)} />
                                </Route>
                                <Route path="/report/friendship/:roomId">
                                    <ReportFriendshipOverview onChange={value => pushValueToMain(value)} />
                                </Route>
                                <Route path="/report/riasec/:roomId/:studentId/:evaluateT?">
                                    <RFResult onChange={value => pushValueToMain(value)} />
                                </Route>
                                <Route path="/report/riasec/:roomId">
                                    <RFReportStudentList onChange={value => pushValueToMain(value)} />
                                </Route>
                                <Route path="/report">
                                    <Report onChange={value => pushValueToMain(value)} />
                                </Route>
                                <Route path="/activity/result">
                                    <ActivityResult onChange={value => pushValueToMain(value)} />
                                </Route>
                                <Route path="/activity/live/:activityId">
                                    <ActivityLive onChange={value => pushValueToMain(value)} />
                                </Route>
                                <Route path="/activity/summary/:activityId">
                                    <ActivitySummary onChange={value => pushValueToMain(value)} />
                                </Route>
                                <Route path="/topic/:topicId">
                                    <TopicPage onChange={value => pushValueToMain(value)} />
                                </Route>
                                <Route path="/activity">
                                    <Activity onChange={value => pushValueToMain(value)} />
                                </Route>
                                <Route path="/evaluate/:roomId/overview">
                                    <RoomOverviewEvaluate onChange={value => pushValueToMain(value)} />
                                </Route>
                                <Route path="/evaluate">
                                    <IndexEvaluate onChange={value => pushValueToMain(value)} />
                                </Route>
                                <Route path="/pocketbook/pdf/:roomIdParams/:stdId">
                                    <GeneratePDF onChange={value => pushValueToMain(value)} />
                                </Route>
                                <Route path="/pocketbook/student/:roomId/:studentId">
                                    <PocketbookStudentDetail onChange={value => pushValueToMain(value)} />
                                </Route>
                                <Route path="/pocketbook/:roomId">
                                    <PocketbookStudentList onChange={value => pushValueToMain(value)} />
                                </Route>
                                <Route path="/riasec/evaluate/:studentId/:assessorParam?">
                                    <RFStudentEvaluate onChange={value => pushValueToMain(value)} />
                                </Route>
                                <Route path="/riasec/:roomId">
                                    <RFStudentList onChange={value => pushValueToMain(value)} />
                                </Route>
                                <Route path="/strength/detail">
                                    <StrengthDetails onChange={value => pushValueToMain(value)} />
                                </Route>
                                <Route path="/">
                                    <Index onChange={value => pushValueToMain(value)} />
                                </Route>
                            </Switch>

                            : (AuthService.getCurrentUser() && AuthService.getUserRole() === 'student') ?

                                <Switch>
                                    <Route path="/pocketbook/pdf">
                                        <GeneratePDF onChange={value => pushValueToMain(value)} />
                                    </Route>
                                    {/* <Route path="/customer">
                                <Customer onChange={value => pushValueToMain(value)} />
                            </Route> */}
                                    {/* <Route path="/about">
                                <Customer onChange={value => pushValueToMain(value)} />
                            </Route>
                            <Route path="/us">
                                <Customer onChange={value => pushValueToMain(value)} />
                            </Route> */}
                                    <Route path="/homeroom">
                                        <Homeroom onChange={value => pushValueToMain(value)} />
                                    </Route>
                                    <Route path="/report/pdffile/:keyType/:activityId/:code/:studentId?">
                                        <PdfFile onChange={value => pushValueToMain(value)} />
                                    </Route>
                                    <Route path="/report/riasec/export/:target/:roomId/:studentId">
                                        <ExportRFResult onChange={value => pushValueToMain(value)} />
                                    </Route>
                                    <Route path="/report/pdfdevelopself/:roomId/:code/:studentId">
                                        <PdfDevelopSelf onChange={value => pushValueToMain(value)} />
                                    </Route>
                                    <Route path="/report/overview/:roomId">
                                        <ReportOverview onChange={value => pushValueToMain(value)} />
                                    </Route>
                                    <Route path="/report/friendship/self-development/:roomId">
                                        <ReportSelfDevelopment onChange={value => pushValueToMain(value)} />
                                    </Route>
                                    <Route path="/report/friendship/export/:target/:roomId/:studentId">
                                        <ExportReportFriendshipTarget onChange={value => pushValueToMain(value)} />
                                    </Route>
                                    <Route path="/report/friendship/:target/:roomId">
                                        <ReportFriendshipTarget onChange={value => pushValueToMain(value)} />
                                    </Route>
                                    <Route path="/report/friendship/:roomId">
                                        <ReportFriendship onChange={value => pushValueToMain(value)} />
                                    </Route>
                                    <Route path="/report/riasec/:roomId/:studentId/:assessorParam?">
                                        <RFResult onChange={value => pushValueToMain(value)} />
                                    </Route>
                                    <Route path="/report">
                                        <Report onChange={value => pushValueToMain(value)} />
                                    </Route>
                                    <Route path="/activity/result">
                                        <ActivityResult onChange={value => pushValueToMain(value)} />
                                    </Route>
                                    <Route path="/activity/live/:activityId">
                                        <ActivityLive onChange={value => pushValueToMain(value)} />
                                    </Route>
                                    <Route path="/activity/summary/:activityId">
                                        <ActivitySummary onChange={value => pushValueToMain(value)} />
                                    </Route>
                                    <Route path="/topic/:topicId">
                                        <TopicPage onChange={value => pushValueToMain(value)} />
                                    </Route>
                                    <Route path="/activity">
                                        <Activity onChange={value => pushValueToMain(value)} />
                                    </Route>
                                    <Route path="/evaluate/person/:roomId/:PersonId">
                                        <PersonEvaluate onChange={value => pushValueToMain(value)} />
                                    </Route>
                                    <Route path="/evaluate/overview/:roomId">
                                        <OverviewEvaluate onChange={value => pushValueToMain(value)} />
                                    </Route>
                                    <Route path="/evaluate/:roomId">
                                        <IndexEvaluate onChange={value => pushValueToMain(value)} />
                                    </Route>
                                    <Route path="/riasec/qr-code">
                                        <RFStudentQRCode onChange={value => pushValueToMain(value)} />
                                    </Route>
                                    <Route path="/riasec/evaluate/:studentId/:assessorParam?">
                                        <RFStudentEvaluate onChange={value => pushValueToMain(value)} />
                                    </Route>
                                    <Route path="/strength/detail">
                                        <StrengthDetails onChange={value => pushValueToMain(value)} />
                                    </Route>
                                    <Route path="/">
                                        <Index onChange={value => pushValueToMain(value)} />
                                    </Route>
                                </Switch>
                                :
                                <Switch>
                                    <Route path="/riasec/meaning">
                                        <RiasecMeaning onChange={value => pushValueToMain(value)} />
                                    </Route>
                                    <Route path="/strength/detail">
                                        <StrengthDetails onChange={value => pushValueToMain(value)} />
                                    </Route>
                                    <Route path="/evaluation/self/:sId">
                                        <ReportSelfDevelopment onChange={value => pushValueToMain(value)} />
                                    </Route>
                                    <Route path="/evaluation/friends/:sId">
                                        <ReportFriendshipTarget onChange={value => pushValueToMain(value)} />
                                    </Route>
                                    <Route path="/report/riasec/export/:target/:roomId/:studentId">
                                        <ExportRFResult onChange={value => pushValueToMain(value)} />
                                    </Route>
                                    <Route path="/riasec/evaluate/:studentId/:assessorParam?">
                                        <RFStudentEvaluate onChange={value => pushValueToMain(value)} />
                                    </Route>
                                    <Route path="/report/riasec/:roomId/:studentId/:assessorParam?">
                                        <RFResult onChange={value => pushValueToMain(value)} />
                                    </Route>
                                    <Route path="/login">
                                        <LoginPage onChange={value => pushValueToMain(value)} />
                                    </Route>
                                    <Route path="/password-created">
                                        <PasswordCreated onChange={value => pushValueToMain(value)} />
                                    </Route>
                                    <Route path="/">
                                        <Index onChange={value => pushValueToMain(value)} />
                                    </Route>
                                </Switch>
                }

            </Router>
        </Col>
    )
}

export default WebRoute